import { DirectiveBinding } from "vue";

// Para utilizar o tooltip
// Adicione v-tooltip em um elemento passando a string a ser exibida
// Ex: <p v-tooltip="'Texto de exemplo'">Informações</p>

function createTooltipElement(text: string): HTMLSpanElement {
  const tooltip = document.createElement("span"); // Cria o elemento do tooltip
  tooltip.className = "tooltip-item"; // Adiciona a classe tooltip-item ao componente
  tooltip.textContent = text;

  return tooltip;
}

const tooltipDirective = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    const tooltipText = binding.value;
    if (!tooltipText) {
      return;
    }

    const tooltipElement = createTooltipElement(tooltipText);
    const close = () => closeTooltip(tooltipElement);
    const show = () => showTooltip(el, tooltipElement);

    // Exibe tooltip ao passar mouse
    el.addEventListener("mouseenter", show);

    // Remove tooltip ao remover mouse
    el.addEventListener("mouseleave", close);
    el.addEventListener("click", close);

    // Remove tooltip ao scrollar tela
    // Necessário para não quebrar layout fixed
    window.addEventListener("scroll", close);

    Object.assign(el, {
      __tooltipCleanup: () => {
        close();
        el.removeEventListener("mouseenter", show);
        el.removeEventListener("mouseleave", close);
        el.removeEventListener("click", close);
        window.removeEventListener("scroll", close);
      },
    });
  },
  beforeUnmount(el: HTMLElement & { __tooltipCleanup?: () => void }) {
    el.__tooltipCleanup?.();
    delete el.__tooltipCleanup;
  },
};

function showTooltip(el: HTMLElement, tooltipElement: HTMLSpanElement) {
  const rect = el.getBoundingClientRect();

  const siblingWidth = el.offsetWidth; // Largura do elemento irmão
  tooltipElement.style.top = `${rect.top - 35}px`;
  tooltipElement.style.left = `${rect.left + siblingWidth / 2}px`; // Centralizar horizontalmente
  tooltipElement.style.transform = "translateX(-50%)"; // Centralizar horizontalmente
  tooltipElement.style.position = "fixed";

  document.body.appendChild(tooltipElement);
}

function closeTooltip(tooltipElement: HTMLSpanElement) {
  if (tooltipElement.parentNode) {
    tooltipElement.parentNode.removeChild(tooltipElement);
  }
}

export default tooltipDirective;
